import styled from 'styled-components/macro'

export const StyledContentContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`
